import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { LoadingState } from '../../../../../types/loading-state';
import { createFetchedData } from '../../../../../utils/fetched-data/create-fetched-data';
import { getFetchedDataPayload } from '../../../../../utils/fetched-data/get-fetched-data-payload';
import { getCacheDuration } from '../../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../../utils/load-data-from-api';
import { assignOrderRelatedData } from '../../../../order/utils/assign-order-related-data';
import { isMemberSignedIn } from '../../../selectors/member/is-member-signed-in';
import { memberHasMoreJourneyResults } from '../../../selectors/member/journeys/member-has-more-journey-results';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
import { MemberJourneyListType } from '../../../types/member-journey-list-type';
import { groupPastJourneys } from '../../../utils/group-past-journeys';
import { setJourneyList } from '../../../utils/set-journey-list';
export const loadPastMemberJourneys = async (limit, startWeekOnSunday, initialLoad) => {
    var _a;
    if (!isMemberSignedIn()) {
        throw new Error('Cannot load recent journeys when user is not signed in.');
    }
    if (initialLoad) {
        runInAction(() => {
            temporaryLoyaltyDomainStore.data.memberJourneys.past = createFetchedData(LoadingState.NotLoaded);
        });
    }
    const state = temporaryLoyaltyDomainStore.data.memberJourneys.past;
    const numberOfJourneys = ((_a = getFetchedDataPayload(state)) === null || _a === void 0 ? void 0 : _a.numberOfJourneys) || 0;
    if (numberOfJourneys && !memberHasMoreJourneyResults(MemberJourneyListType.Recent))
        return;
    await loadDataFromApi({
        api: () => ocapiClient.instance.v1.loyalty.members.journeys.getPast({ limit, offset: numberOfJourneys }),
        state,
        cacheDuration: getCacheDuration('journeys'),
        onSuccess: (response, cacheDuration) => onSuccess(response, cacheDuration, startWeekOnSunday)
    });
};
const onSuccess = (response, cacheDuration, startWeekOnSunday) => {
    const { results, relatedData, hasMoreResults } = response;
    const data = getFetchedDataPayload(temporaryLoyaltyDomainStore.data.memberJourneys.past);
    const numberOfJourneys = (data === null || data === void 0 ? void 0 : data.numberOfJourneys) || 0;
    const oldJourneyGroups = data === null || data === void 0 ? void 0 : data.journeyGroups;
    assignOrderRelatedData(relatedData, cacheDuration);
    setJourneyList(results);
    const newJourneyGroups = groupPastJourneys(results, startWeekOnSunday, oldJourneyGroups);
    const journeyGroups = oldJourneyGroups ? [...oldJourneyGroups, ...newJourneyGroups] : newJourneyGroups;
    return { journeyGroups, hasMoreResults, numberOfJourneys: numberOfJourneys + results.length };
};
